import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

import { trTR } from "@material-ui/core/locale";

// A custom theme for this app
const theme = createMuiTheme(
  {
    palette: {
      primary: {
        main: "#5D3EBD",
      },
      secondary: {
        main: "#7849F7",
      },
      success: {
        main: "#4caf50",
      },
      error: {
        main: "#f44336",
      },
      warning: {
        main: "#ff9800",
      },
      background: {
        default: "#f4f6f8",
      },
      text: {
        primary: "#263238",
      },
      textSecondary: {
        main: "#fff",
      },
    },
    typography: {
      h3: {
        fontSize: "24px",
        lineHeight: "28px",
        letterSpacing: "-0.06px;",
      },
      h5: {
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "-0.05px",
      },
    },
    overrides: {
      MuiButton: {
        root: {
          textTransform: "capitalize",
        },
      },
      MuiListItem: {
        root: {
          textTransform: "capitalize",
        },
      },
      MuiPaper: {
        elevation1: {
          boxShadow:
            "0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)",
        },
      },
      MuiListItemText: {
        root: {
          maxWidth: "130px",
        },
        primary: {
          fontSize: "12px",
        },
        secondary: {
          fontSize: "16px",
          fontWeight: 600,
          color: "#5D3EBD",
        },
      },
      MuiAvatar: {
        root: {
          border: "1px solid #ccc",
        },
      },
      MuiListItemSecondaryAction: {
        root: {
          right: 0,
        },
      },
      MuiStepper: {
        root: {
          marginBottom: 24,
        },
      },
      MuiSnackbarContent: {
        root: {
          backgroundColor: red.A400,
        },
      },
    },
  },
  trTR
);

export default theme;
